"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import React from "react";
import $ from "jquery";
import _ from "underscore";
import Account from "../api/account";
import Api from "../api/api";
import Auth from "../util/auth";
import fetch from "../util/fetch";
import ApiService from "../services/api_service";
import DataStoreService from "./data_store_service";
import DocumentIndexerService from "./document_indexer_service";
import DocumentsService from "./documents_service";
import get from "./data/get";
import WaitingSpinner from "../components/waiting_spinner";
import { DocumentIndexer } from "./react_indexer";
import {
  GroupedDocumentBrowserModel,
  GroupIDGroupCreator
} from "./grouped_document_browser_model";
import { History } from "react-router";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import { isIndexerMode } from "./index_audit_split_mode";
import { Flash } from "../components/flash";
import { maybePrefetchNextFlowModeItem } from "./flow_mode/flow_mode_service";
import CarrierInvoicesStore from "../stores/carrier_invoices_store";
import { fetchDocumentLoadRelationships } from "./helpers/document_load_relationship_fetcher";
import { factorInvoiceWorkflowBatch } from "./flow_mode/dashboard_paths";
const DocumentIndexerPage = React.createClass({
  mixins: [History],
  getInitialState: function() {
    return {
      documentLoadRelationships: []
    };
  },
  componentWillReceiveProps: function(nextProps) {
    if (nextProps.params.batchId != this.props.params.batchId) {
      DocumentsService.getUncachedDocumentBatch(nextProps.params.batchId).then(
        this.updateDocumentBatch
      );
    }
  },
  componentWillMount: function() {
    const batchID = this.props.params.batchId;
    DocumentsService.getUncachedDocumentBatch(batchID).then(this.updateDocumentBatch).then(() => {
      if (this.maybeRedirectToWorkflowPage()) {
        return;
      }
      $(DataStoreService).on(
        "DataStoreService:documentGroupUpdated",
        _.partial(this.updateExistingBatch, null)
      );
      $(DataStoreService).on(
        "DataStoreService:documentBatchUpdated",
        this.documentBatchUpdatedCallback
      );
      $(DataStoreService).on(
        "DataStoreService:documentPageReplaced",
        this.pageReplaced
      );
      $(DataStoreService).on(
        "DataStoreService:factorInvoiceUpdated",
        this.factorInvoiceUpdatedCallback
      );
    });
  },
  componentDidMount() {
    return __async(this, null, function* () {
      yield maybePrefetchNextFlowModeItem(this.props.location);
    });
  },
  componentWillUnmount: function() {
    $(DataStoreService).off(
      "DataStoreService:documentGroupUpdated",
      this.updateExistingBatch
    );
    $(DataStoreService).off(
      "DataStoreService:documentBatchUpdated",
      this.documentBatchUpdatedCallback
    );
    $(DataStoreService).off(
      "DataStoreService:documentPageReplaced",
      this.updateExistingBatch
    );
    $(DataStoreService).off(
      "DataStoreService:factorInvoiceUpdated",
      this.factorInvoiceUpdatedCallback
    );
  },
  maybeRedirectToWorkflowPage: function() {
    var _a, _b;
    if (!Account.useFactorInvoiceWorkflowPage() || ((_b = (_a = this.props.location) == null ? void 0 : _a.query) == null ? void 0 : _b.forceReact)) {
      return false;
    }
    return this.redirectToWorkflowPage();
  },
  // Called when a forced React step (entered via forceReact=true&step=<step>)
  // completes. The mount-time forceReact guard keeps the user in React on entry;
  // once the step is done we return to the workflow page, which drops the
  // forceReact/step params from the URL.
  returnToWorkflowPageAfterForcedStep: function() {
    if (!Account.useFactorInvoiceWorkflowPage()) {
      return false;
    }
    return this.redirectToWorkflowPage();
  },
  redirectToWorkflowPage: function() {
    var _a, _b, _c, _d, _e, _f, _g;
    const selectedGroupId = (_b = (_a = this.state.model) == null ? void 0 : _a.selectedGroup) == null ? void 0 : _b.id;
    const documentGroup = _.findWhere(
      (_c = this.state.documentBatch) == null ? void 0 : _c.document_groups,
      { id: selectedGroupId }
    );
    const factorInvoice = _.findWhere(
      (_d = this.state.documentBatch) == null ? void 0 : _d.factor_invoices,
      { id: documentGroup == null ? void 0 : documentGroup.factor_invoice_id }
    );
    const emailId = (_e = this.state.documentBatch.email_message) == null ? void 0 : _e.id;
    if ((factorInvoice == null ? void 0 : factorInvoice.id) && emailId) {
      const batchId = this.state.documentBatch.id;
      const target = factorInvoiceWorkflowBatch(
        batchId,
        emailId,
        factorInvoice.id,
        (_g = (_f = this.props.location) == null ? void 0 : _f.query) == null ? void 0 : _g.onDone
      );
      this.history.replaceState(null, target.toString());
      return true;
    }
    return false;
  },
  pageReplaced: function(args, page) {
    if (page && this.pageIsForMyModel(page)) {
      var currentPage = this.state.model.selectedPage;
      const isUpdatedVersionOfCurrentPage = currentPage && currentPage.document_id === page.document_id && currentPage.number === page.number;
      if (isUpdatedVersionOfCurrentPage) {
        this.updateExistingBatch(page);
      } else {
        this.updateExistingBatch(currentPage);
      }
    }
  },
  factorInvoiceUpdatedCallback: function() {
    if (this.state.documentBatch) {
      this.updateExistingBatch();
    }
  },
  pageIsForMyModel: function(page) {
    if (this.state.model) {
      return this.state.model._documentForPage(page);
    }
    return false;
  },
  updateExistingBatch: function(page) {
    this.updateDocumentBatch(this.state.documentBatch, page);
    this.forceUpdate();
  },
  documentsExceptionAddedCallback: function() {
    this.setState({ forceComputeStartPage: true });
    return this.reloadDocumentBatch();
  },
  reloadDocumentBatch() {
    return DocumentsService.getUncachedDocumentBatch(
      this.state.documentBatch.id
    ).then(this.updateDocumentBatch);
  },
  onMergeDocumentBatches: function() {
    const page = this.state.model.selectedPage;
    DocumentsService.getUncachedDocumentBatch(this.state.documentBatch.id).then(
      (documentBatch) => {
        this.updateDocumentBatch(documentBatch, page);
      }
    );
  },
  factorInvoiceAbandonedCallback: function() {
    this.setState({ forceComputeStartPage: false });
    Promise.resolve().then(() => {
      return DocumentsService.getUncachedDocumentBatch(
        this.state.documentBatch.id
      );
    }).then((batch) => {
      return this.updateDocumentBatch(batch);
    }).catch(console.error);
  },
  documentBatchUpdatedCallback: function(event, documentBatch) {
    if (documentBatch.id === this.state.documentBatch.id) {
      this.updateDocumentBatch(documentBatch);
    }
  },
  updateDocumentBatch: function(documentBatch, page) {
    if (this.isMounted()) {
      const model = new GroupedDocumentBrowserModel(
        new GroupIDGroupCreator(
          documentBatch.documents,
          documentBatch.document_groups
        ),
        this.documentIsCompleteCreator(documentBatch),
        page || this.startPage(documentBatch)
      );
      const leftDocumentModel = new GroupedDocumentBrowserModel(
        new GroupIDGroupCreator(
          documentBatch.documents,
          documentBatch.document_groups
        ),
        this.documentIsCompleteCreator(documentBatch),
        page || this.startPage(documentBatch)
      );
      const indexerService = DocumentIndexerService(
        documentBatch,
        DataStoreService,
        Api.Account,
        this.props.location,
        this.history
      );
      this.setState({
        model,
        leftDocumentModel,
        documentIndexerService: indexerService,
        documentBatch,
        forceComputeStartPage: false,
        loaded: true
      });
      return documentBatch;
    }
  },
  updateDocumentLoadRelationships: function(loadStateIds) {
    if (!this.isMounted()) {
      return;
    }
    const documentIds = this.state.documentBatch.documents.map(
      (doc) => doc.id
    );
    fetchDocumentLoadRelationships(
      documentIds,
      loadStateIds,
      (relationships) => {
        if (this.isMounted()) {
          this.setState({
            documentLoadRelationships: relationships
          });
        }
      }
    );
  },
  content: function() {
    if (this.state.loaded) {
      if (this.state.documentBatch.documents.length == 0) {
        Flash.alert("Document batch failed to load: Group has 0 documents", {
          timeout: 1e8
        });
        return;
      }
      if (this.state.documentBatch.documents.some(
        (doc) => !doc.pages || doc.pages.length === 0
      )) {
        this.logCurrentStateOfBatch();
        Flash.alert("Document batch failed to load: Document has 0 pages", {
          timeout: 1e8
        });
        return;
      }
      return /* @__PURE__ */ React.createElement(
        DocumentIndexer,
        {
          hasMore: this.hasMore(),
          model: this.state.model,
          leftDocumentModel: this.state.leftDocumentModel,
          documentIndexerService: this.state.documentIndexerService,
          documentBatch: this.state.documentBatch,
          carrier: get.carrierPromise(this.state.documentBatch),
          documentsExceptionAddedCallback: this.documentsExceptionAddedCallback,
          factorInvoiceAbandonedCallback: this.factorInvoiceAbandonedCallback,
          onMergeDocumentBatches: this.onMergeDocumentBatches,
          allowsEditing: true,
          assignCurrentGroupToLoadAndInvoiceId: this.assignCurrentGroupToLoadAndInvoiceId,
          assignCurrentGroupToLoad: this.assignCurrentGroupToLoad,
          location: this.props.location,
          forceComputeStartPage: this.forceComputeStartPage,
          skipStep: this.goToNextGroupOrDashboard,
          returnToWorkflowPageAfterForcedStep: this.returnToWorkflowPageAfterForcedStep,
          maybeRedirectToWorkflowPage: this.maybeRedirectToWorkflowPage,
          reloadDocumentBatch: this.reloadDocumentBatch,
          updateDocumentLoadRelationships: this.updateDocumentLoadRelationships,
          documentLoadRelationships: this.state.documentLoadRelationships
        }
      );
    }
    return /* @__PURE__ */ React.createElement("div", null);
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      WaitingSpinner,
      {
        "data-component": "DocumentIndexerPage",
        when: this.state.waiting || !this.state.loaded
      },
      this.content()
    );
  },
  firstPageForGroup: function(group) {
    return _.first(_.first(group.documents).pages);
  },
  incompleteGroups: function() {
    return this.inIndexerMode() ? this.state.model.indexerGroups() : this.state.model.incompleteGroups();
  },
  hasMore: function() {
    const incompleteGroups = this.incompleteGroups();
    if (incompleteGroups.length === 0) {
      return false;
    }
    if (incompleteGroups.length > 1) {
      return true;
    }
    return incompleteGroups[0] !== this.state.model.selectedGroup;
  },
  inIndexerMode: function() {
    return isIndexerMode(this.props.location);
  },
  goToNextGroupOrDashboard() {
    const hasMore = this.hasMore();
    if (hasMore) {
      if (this.inIndexerMode()) {
        const nextPage = this.firstPageForGroup(
          _.first(this.incompleteGroups())
        );
        this.state.model.selectPage(nextPage);
      } else {
        this.setState({ forceComputeStartPage: true });
        return this.reloadDocumentBatch();
      }
    } else {
      ToDashboardWithFilters(this.props.location, this.history);
    }
  },
  goToLoadAndReturn: function(loadId, carrierInvoiceId, isFirstLoad) {
    const newLocation = this.props.location.query.onDone || "/dashboard";
    const filters = this.props.location.query.filters;
    const hasMore = this.hasMore();
    const emailId = this.props.location.query.emailId;
    const next = hasMore ? this.props.location.pathname + "?onDone=" + encodeURIComponent(newLocation) : newLocation;
    const invoice = CarrierInvoicesStore.find(carrierInvoiceId);
    let url;
    if (invoice == null ? void 0 : invoice.requires_ltl_reconciliation) {
      url = `/loads/${loadId}/carrier_invoices/${carrierInvoiceId}/ltl-reconcile`;
    } else {
      url = `/index-document-batches/${this.state.documentBatch.id}/loads/${loadId}/carrier_invoices/${carrierInvoiceId}`;
    }
    this.history.pushState(null, url, {
      hasMore,
      onDone: next,
      filters,
      emailMessageId: this.state.documentBatch.email_message.id,
      isFirstLoad,
      emailId
    });
  },
  assignCurrentGroupToLoadAndInvoiceId: function(loadStateId, carrierInvoiceId, carrierInvoice, carrierID, isFirstLoad, assignCustomerOnlyDocuments, shipmentDocumentSelections, deliveryDocumentSelections) {
    this.setState({ waiting: true });
    const docs = this.state.model.activeDocuments();
    const shipmentDocumentSelectionIds = shipmentDocumentSelections == null ? void 0 : shipmentDocumentSelections.map(
      (shipmentDocumentSelection) => {
        const documentIds = shipmentDocumentSelection.documents.map(
          (doc) => doc.id
        );
        const shipmentId = shipmentDocumentSelection.shipment.tms_shipment_id;
        return { document_ids: documentIds, shipment_id: shipmentId };
      }
    );
    return ApiService.addErrorHandler(
      fetch("/api/documents/assign_documents_to_new_or_existing_invoice", {
        data: {
          load_state_id: loadStateId,
          carrier_id: carrierID,
          carrier_invoice_id: carrierInvoiceId,
          carrier_invoice: carrierInvoice,
          document_ids: docs.map((d) => d.id),
          assign_customer_only_documents: assignCustomerOnlyDocuments,
          shipment_document_selections: shipmentDocumentSelectionIds,
          delivery_document_selections: deliveryDocumentSelections
        },
        method: "post"
      }),
      null,
      { caller: "DocumentIndexerPage.assignCurrentGroupToLoadAndInvoiceId" }
    ).then((data) => {
      DataStoreService.updateStores(data);
      if (this.inIndexerMode()) {
        this.goToNextGroupOrDashboard();
      } else {
        this.goToLoadAndReturn(
          data.load_state_id,
          data.carrier_invoice_id,
          isFirstLoad
        );
      }
    }).catch((error) => {
      this.setState({ waiting: false });
      return error;
    });
  },
  assignCurrentGroupToLoad(loadStateId, carrierID, deliveryDocumentSelections) {
    this.setState({ waiting: true });
    const docs = this.state.model.activeDocuments();
    const navigateToNonInvoiceConfirmPage = () => {
      const url = `/index-document-batches/${this.state.documentBatch.id}/loads/${loadStateId}/confirm`;
      const onDone = this.props.location.query.onDone || "/app/dashboard";
      const params = this.hasMore() ? {} : { onDone };
      this.history.pushState(null, url, params);
    };
    return ApiService.addErrorHandler(
      fetch("/api/documents/assign_documents_to_non_invoice_load", {
        data: {
          load_state_id: loadStateId,
          carrier_id: carrierID,
          document_ids: docs.map((d) => d.id),
          delivery_document_selections: deliveryDocumentSelections
        },
        method: "post"
      }),
      null,
      { caller: "DocumentIndexerPage.assignCurrentGroupToLoad" }
    ).then((data) => {
      DataStoreService.updateStores(data);
      return this.showNonInvoiceConfirmPage() ? navigateToNonInvoiceConfirmPage() : this.goToNextGroupOrDashboard();
    }).catch((error) => {
      this.setState({ waiting: false });
      return error;
    });
  },
  showNonInvoiceConfirmPage() {
    return Auth._currentUser.account.settings.feature_enable_non_invoice_flow && !this.inIndexerMode();
  },
  startPage: function(documentBatch) {
    if (this.state.forceComputeStartPage) {
      return null;
    }
    return this.startPageFromExistingModel() || this.startPageFromURL(documentBatch);
  },
  forceComputeStartPage: function() {
    this.setState({ forceComputeStartPage: true }, this.updateExistingBatch);
  },
  startPageFromExistingModel: function() {
    if (this.state.model) {
      return this.state.model.selectedPage;
    }
  },
  startPageFromURL: function(documentBatch) {
    const groupId = this.props.location.query.group_id;
    const invoiceId = this.props.location.query.invoiceId;
    if (!groupId && !invoiceId) {
      return;
    }
    if (groupId) {
      var query = (d) => {
        return d.document_group_id === parseInt(groupId, 10);
      };
    } else {
      var query = (d) => {
        return d.factor_invoice_id === parseInt(invoiceId, 10) || d.carrier_invoice_id === parseInt(invoiceId, 10);
      };
    }
    const startDoc = _.find(documentBatch.documents, query);
    if (startDoc) {
      return startDoc.pages[0];
    }
  },
  documentIsCompleteCreator: function(documentBatch) {
    const docs = documentBatch.documents;
    if (docs.every((d) => d.type)) {
      return (doc) => {
        const docsForGroup = docs.filter(
          (d) => d.document_group_id === doc.document_group_id
        );
        return docsForGroup.every((d) => d.finished);
      };
    }
    return (doc) => doc.type;
  },
  logCurrentStateOfBatch: function() {
    console.trace();
    console.log("Document Batch Groups");
    this.state.documentBatch.document_groups.forEach((group) => {
      console.log("Document group id: " + group.id);
    });
    console.log("\nDocument batch by documents");
    this.state.documentBatch.documents.forEach((doc) => {
      console.log("Document id: " + doc.id);
      console.log("- Document group id: " + doc.document_group_id);
      console.log(
        "- Document group position (data.group_id): " + doc.data.group_id
      );
      if (doc.pages) {
        doc.pages.forEach((page) => {
          console.log("- Document page id: " + page.id);
        });
      }
    });
  }
});
export default DocumentIndexerPage;
